import PropTypes from 'prop-types';
import {
	Paper,
	Box,
	Typography,
	FormControl,
	Select,
	MenuItem,
	Tooltip,
} from '@mui/material';
import InfoOutlined from '@mui/icons-material/InfoOutlined';

// Tenant Level - Tenant Admin page controls this setting
// User Level - Email Sync page controls this setting
const EmailDirectionDropdown = ({
	emailDirection,
	onEmailDirectionChange,
	tenantLevel,
}) => {
	return (
		<Paper
			variant='outlined'
			sx={ (theme) => ({
				px: 3,
				py: 2,
				mb: 2,
				borderRadius: 0.8,
				backgroundColor: theme.palette.background.default,
			})}
		>
			<Box sx={{ mb: 2 }}>
				<Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
					<Typography
						variant='subtitle1'
						sx={{ fontWeight: 600, mb: 0.1, fontSize: '0.9rem' }}
					>
						Email Ingestion Direction
					</Typography>

					{!tenantLevel && (
						<Tooltip
							title='This setting is controlled by your tenant admin'
							placement='top'
							arrow
							slotProps={{
								tooltip: {
									sx: {
										borderRadius: '5px',
									},
								},
							}}
						>
							<InfoOutlined
								sx={{
									fontSize: '1rem',
									color: 'text.secondary',
									cursor: 'help',
									mb: 0.3,
								}}
							/>
						</Tooltip>
					)}
				</Box>
				<Typography
					variant='body2'
					color='text.secondary'
					sx={{ fontSize: '0.8rem' }}
				>
					Choose which emails to sync to your CRM
				</Typography>
			</Box>
			<FormControl fullWidth sx={(theme) => ({ backgroundColor: theme.palette.background.paper })}>
				<Select
					value={emailDirection}
					onChange={(e) => onEmailDirectionChange(e.target.value)}
					disabled={!tenantLevel}
				>
					<MenuItem value='received'>Ingest received emails</MenuItem>
					<MenuItem value='sent'>Ingest sent emails</MenuItem>
					<MenuItem value='received_and_sent'>
						Ingest both received & sent emails
					</MenuItem>
				</Select>
			</FormControl>
		</Paper>
	);
};

EmailDirectionDropdown.propTypes = {
	emailDirection: PropTypes.string,
	onEmailDirectionChange: PropTypes.func.isRequired,
	tenantLevel: PropTypes.bool.isRequired,
};

export default EmailDirectionDropdown;
